import React, { ReactNode } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './App.css';
import { GoogleOAuthProvider } from '@react-oauth/google';

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import { HomePage } from './HomePage';


/*const postSignOut = () => window.location.assign("/");
const useStateAuthentication = (configuration: Configuration) => {
  if (configuration.get("mock.auth") === "true") {


    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useStateMockAuthentication(configuration, postSignOut);
  } else {

    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useStateAmazonCognitoAuthentication(configuration, postSignOut);
  }
};

//us-west-2i0xk035ih.auth.us-west-2.amazoncognito.com
//cognito-idp.us-west-2.amazonaws.com/us-west-2_I0xK035ih

const stdConfig = (key: string): string | undefined => {
  switch (key) {
    case "cognito.region":
      return "us-west-2";
    case "cognito.userpoolid":
      return "us-west-2_I0xK035ih";
    case "cognito.userpoolwebclientid":
      return "3fko3o1srnmrvu75ki4hgrabk7";
    case "cognito.oauthdomain":
      return "us-west-2i0xk035ih.auth.us-west-2.amazoncognito.com";
    case "mock.auth":
      return "true";
    default:
      return undefined;
  }
}




const AwaitConfiguration = ({ children }: { children: ReactNode }) => {
  const configuration: Configuration = {
    loaded: true,
    get: stdConfig,
  }

  return configuration.loaded ? (
    <ConfigurationContext.Provider value={configuration}>
      {children}
    </ConfigurationContext.Provider>
  ) : null;
};

const AwaitAuthentication = ({ children }: { children: ReactNode }) => {
  const configuration = React.useContext(ConfigurationContext);
  const authState = useStateAuthentication(configuration);

  return (
    <AuthenticationContext.Provider value={authState}>
      {children}
    </AuthenticationContext.Provider>
  );
};*/


//const defaultParty = "https://fanbox-eventservice-usercontent-popcorn-preprod.s3.us-west-2.amazonaws.com/party/default-party.json";



const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

const googleClientId = '835121614665-kuh77kbndgiuho87r66biiq022malkkt.apps.googleusercontent.com';


function App() {
  //const partyProps : PartyProps = { party : usePartyFile(), user : useDefaultUser() };




  /*const CreateFauxSchedule = (): ScheduleConfigProps => {

    const ret: ScheduleConfigProps = DefaultScheduleSmall();

    for (let i = 0; i < ret.channels.length; i++) {
      const count = ret.channels[i].programs.length;
      var counter = 0;
      for (let j = count; j < 48; j++) {
        const p: ScheduleProgram = {
          start: j * 0.5,
          end: (j + 1) * 0.5,
          name: ret.channels[i].programs[counter].name,
          description: ret.channels[i].programs[counter].name,
          image: ret.channels[i].programs[counter].image,
          category : ret.channels[i].programs[counter].category,
          categoryColor : ret.channels[i].programs[counter].categoryColor

        }
        counter++;
        if (counter >= count)
          counter = 0;
        ret.channels[i].programs.push(p);
      }
    }



    return ret;
  }*/


  const fileChangeHandler = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files !== null) {
      const files = event.target.files;
      if (files.length > 0) {
        const file = files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
          const arrayBuffer = event.target?.result as ArrayBuffer;
          const bytes = new Uint8Array(arrayBuffer);
          var encodeHex = '';
          bytes.forEach((byte)=> {
          encodeHex += (byte % 256).toString(16);
          console.log(encodeHex);
      });
          
        };

        reader.readAsArrayBuffer(file);
      }
      
    }

  }

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
    <ThemeProvider theme={darkTheme}>
            <CssBaseline />

              <Router>
                <Switch>
                  <Route path="/signin-callback">
                    <div style={{ width: "750px", height: "500px", backgroundColor: "darkblue", color: "white" }}>
                      <h1>This was a re-route</h1>
                      <input type='file' onChange={(event) => { fileChangeHandler(event); }} />
                    </div>
                  </Route>
                  <Route path='/dev/:partyId/:offset' render={props => <HomePage {...props.match.params}/>}/>
                  <Route path='/devuser/:partyId/:offset/:userId' render={props => <HomePage {...props.match.params}/>}/>
                  <Route path="/" render={props => <HomePage/>} />

                </Switch>
              </Router>
    </ThemeProvider>
    </GoogleOAuthProvider>

  );

}
//<SignInPanel {...signinProps} />

export default App;
